import { useLogger } from "@sb1finans/components/dist/SB1Logger";
import {
  Alert,
  Button,
  Container,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useCurrentAgreementId } from "../utils/route-hooks";
import { useAccount } from "../state/AppDataStateProvider";
import { accountsApi } from "../api";

const TermDatePage = () => {
  const agreementId = useCurrentAgreementId();
  const account = useAccount();
  const [success, setSuccess] = useState<boolean>();
  const [error, setError] = useState<Error | null>(null);
  const [date, setDate] = useState<string>("");
  const logger = useLogger();

  function getNextDateString(targetDay: number, today = new Date()) {
    const year = today.getFullYear();
    const month = today.getMonth(); // 0-based
    const currentDay = today.getDate();

    // If target day is still ahead in this month, use this month.
    // Otherwise, use next month.
    const result = new Date(
      year,
      targetDay > currentDay ? month : month + 1,
      targetDay + 1,
    );

    // Format as yyyy-MM-dd
    return result.toISOString().slice(0, 10);
  }

  console.log("NExt day is: ", getNextDateString(Number(date)));
  const setTermDate = async () => {
    if (Number(date) < 1 || Number(date) > 28) {
      return;
    }
    try {
      if (account?.id == null) {
        logger.error("Account ID is null, cannot set term date");
        setError(new Error("Account ID is null"));
        setSuccess(false);
        return;
      }
      const termDate = getNextDateString(Number(date));
      const paymentPlan = await accountsApi.updateAccountPaymentPlan(
        agreementId,
        account.id,
        termDate,
      );
      logger.info("Term date set successfully");
      setSuccess(true);
    } catch (error) {
      logger.error("Error setting term date", error);
      setSuccess(false);
      setError(new Error("Error setting term date"));
    }
  };

  return (
    <Container maxWidth="md">
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Forfallsdatoen ble endret.
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Kunne ikke endre fordallsdato. Prøv igjen senere.
        </Alert>
      )}
      <Stack spacing={2}>
        <Typography variant="h4" gutterBottom>
          Endre forfallsdato
        </Typography>
        <Typography variant="body1" gutterBottom>
          Her kan du endre forfallsdatoen på dine fakturaer. Vennligst velg
          ønsket dato i feltet under.
        </Typography>
        <Typography variant="body2" gutterBottom>
          Merk at endringen ikke vil påvirke allerede utstedte fakturaer.
        </Typography>
        <TextField
          label="Ønsket forfallsdato"
          type="number"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          error={Number(date) < 1 || Number(date) > 28}
          helperText={
            Number(date) < 1 || Number(date) > 28
              ? "Vennligst velg en dato mellom 1 og 28"
              : ""
          }
          InputLabelProps={{
            shrink: true,
          }}
        />
        <Button variant="contained" onClick={() => setTermDate()}>
          Endre forfallsdato
        </Button>
      </Stack>
    </Container>
  );
};

export default TermDatePage;
